import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getActiveSessions = createAsyncThunk('user/sessions', async () => {
	return await AccountService.getActiveSessions();
});
